export default {"src":"/_next/static/media/company-shipping-data.a1d0e154.svg","height":63,"width":87};